<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="商品编码" prop="goodsCode">
            <el-input v-model.trim="searchForm.goodsCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="商品名称" prop="goodsName">
            <el-input v-model.trim="searchForm.goodsName" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="importExcel" v-if="isShowEdit">导入</el-button>
        <el-button type="primary" size="mini" @click="isShowAdd = true" v-if="isShowEdit">新增</el-button>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.records"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column label="图片" width="60">
          <template slot-scope="{ row }">
            <el-button type="text" @click="showImg(row.photoList)" v-if="row.photoList && row.photoList.length">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="商品编码" prop="goodsCode"></el-table-column>
        <el-table-column label="商品名称" prop="goodsName"></el-table-column>
        <el-table-column label="操作" align="center" width="80" v-if="isShowEdit">
          <template slot-scope="scope">
            <el-button type="text" style="color: red" size="mini" @click="delRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <edit-dialog :visible.sync="isShowAdd" v-if="isShowAdd" @success="onSearch" />
    <el-dialog title="查看图片" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </content-panel>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import imgShow from "@/views/components/imgShow.vue";
import { downloadFile } from "@/utils";
import moment from "moment";
import editDialog from "./add.vue";
export default {
  name: "LeisureProducts",
  mixins: [tableMixin, pagePathMixin],
  components: { editDialog, imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      loading: false,
      searchForm: {
        goodsCode: "",
        goodsName: "",
      },
      exportData: {},
      searchCollapse: false,
      isShowAdd: false,
      dialogFormVisible: false,
      productTypeList: [],
      imgList: [],
    };
  },
  computed: {
    permitList() {
      return JSON.parse(localStorage.getItem("permitList"))
    },
    isShowEdit() {
      return this.permitList.includes('ec-pc-new$dataImport$preSalePlan$leisureProducts$edit')
    },
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },
    async init() {
      this.loading = true;
      let data = {
        filterData: {
          ...this.searchForm,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.searchFormData = data.filterData
      this.$q.dataImport
        .unAssessGoodsSearch({ data: data })
        .then((res) => {
          if (res.success) {
            this.tableData = res.data;
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.tableData.pageNum = 1;
      this.onSearch();
    },

    async delRow(row) {
      let status = await this.$confirm("是否确认删除该条数据？", "提示", { type: "warning" });
      if (status !== "confirm") return;
      let res = await this.$q.dataImport.unAssessGoodsDel({ data: [row.dataId] });
      if (res.success) {
        this.$message.success("删除成功");
      } else {
        this.$message.fail("删除失败");
      }
      this.onSearch();
    },

    showImg(imgList) {
      this.imgList = imgList.map((v) => v.path);
      this.dialogFormVisible = true;
    },

    importExcel() {
      this.openSubPage({
        path: "/leisureProductsImport",
        query: {
          fileName: "休闲产品不考核导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },

    // 不是自定义列导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: 'prePlanUnAssessGoods'
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
